import React from 'react';

const Search = () => {
  return (
    <div>
      <input type="text" />
      asdasdasdasd
    </div>
  )
}

export default Search;